import {ENUMS} from "../services/enums";
import utils from "../services/utils";

const state = () => ({
  selectedPipelineViewId: 0,
});

const getters = {
  pipelineViews(state, getters, rootState) {
    let views = rootState.account.pipelineViews;
    return views.sort((a, b) => (a.label > b.label) ? 1 : -1)
  },
  selectedPipelineView(state, getters, rootState, rootGetters) {
    return rootGetters["activePipelineView/activePipelineView"];
  },
  statusesWithTrashed(state, getters, rootState) {
    return [...rootState.account.statuses]
      .sort((a, b) => a.order - b.order);
  },
  statuses(state, getters, rootState) {
    return [...rootState.account.statuses]
      .filter(status => status.deleted_at !== null)
      .sort((a, b) => a.order - b.order);
  },
  getStatusById: (state, getters) => (statusId) => {
    return getters.statusesWithTrashed.find(status => status.id === statusId);
  },
  getStateLabelByStatusId: (state, getters) => (statusId) => {
    const status = getters.getStatusById(statusId);
    return utils.newGetEnumLabel(status.state, ENUMS.StatusStateEnum);
  },
  statusesInView(state, getters) {
    if (getters.selectedPipelineView) {
      const view = getters.selectedPipelineView
      return getters.statuses.filter(status => view.status_ids.includes(status.id));
    }
    return getters.statuses;
  },
  contactingStatuses(state, getters) {
    return getters.statuses.filter((status) => status.state === ENUMS.StatusStateEnum.Contacting.value);
  },
  contactingStatusesInView(state, getters) {
    if (getters.selectedPipelineView) {
      const view = getters.selectedPipelineView
      return getters.contactingStatuses.filter(status => view.status_ids.includes(status.id));
    }
    return getters.contactingStatuses;
  },
  activeStatuses(state, getters) {
    return getters.statuses.filter((status) => status.state === ENUMS.StatusStateEnum.Active.value);
  },
  activeStatusesInView(state, getters) {
    if (getters.selectedPipelineView) {
      const view = getters.selectedPipelineView
      return getters.activeStatuses.filter(status => view.status_ids.includes(status.id));
    }
    return getters.activeStatuses;
  },
  followUpStatuses(state, getters) {
    return getters.statuses.filter((status) => status.state === ENUMS.StatusStateEnum.FollowUp.value);
  },
  followUpStatusesInView(state, getters) {
    if (getters.selectedPipelineView) {
      const view = getters.selectedPipelineView
      return getters.followUpStatuses.filter(status => view.status_ids.includes(status.id));
    }
    return getters.followUpStatuses;
  },
  completedStatuses(state, getters) {
    return getters.statuses.filter((status) => status.state === ENUMS.StatusStateEnum.Completed.value);
  },
  completedStatusesInView(state, getters) {
    if (getters.selectedPipelineView) {
      const view = getters.selectedPipelineView
      return getters.completedStatuses.filter(status => view.status_ids.includes(status.id));
    }
    return getters.completedStatuses;
  },
  deadStatuses(state, getters) {
    return getters.statuses.filter((status) => status.state === ENUMS.StatusStateEnum.Dead.value);
  },
  deadStatusesInView(state, getters) {
    if (getters.selectedPipelineView) {
      const view = getters.selectedPipelineView
      return getters.deadStatuses.filter(status => view.status_ids.includes(status.id));
    }
    return getters.deadStatuses;
  },
  nonLeadStatuses(state, getters) {
    return getters.statuses.filter((status) => status.state === ENUMS.StatusStateEnum.NonLead.value);
  },
  nonLeadStatusesInView(state, getters) {
    if (getters.selectedPipelineView) {
      const view = getters.selectedPipelineView
      return getters.nonLeadStatuses.filter(status => view.status_ids.includes(status.id));
    }
    return getters.nonLeadStatuses;
  },
};

const mutations = {
};

const actions = {};

const PipelineStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default PipelineStore;
